import {
    TableBody,
    TableRow,
    TableCell,
    CircularProgress,
    IconButton,
    SxProps,
    Theme,
} from "@mui/material";
import { EmptyTable } from "../../../modules/clients/components/EmptyState";
import { TableItem, TableRowType } from "../RopTable/RopTable";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useEffect, useState } from "react";
import RopCollapsibleHistoryTable from "./RopCollapsibleHistoryTable";

export type CollapsibleTableRowType = {
    rowItems?: TableItem[];
    onClick?: () => void;
    historyHeaders: TableItem[];
    historyRows?: TableRowType[];
}
type RopTableRowProps = {
    hover?: boolean;
    title?: string;
    itemsHeaders?: TableItem[];
    collapsibleTable?: CollapsibleTableRowType[];
    isLoading?: boolean;
    historyTableColSpan?: number;
    historyTableCellSx?: SxProps<Theme>;
    saveCollapsable?: boolean;
    initialSelectedItem?: string;
};

export default function RopTableCollapsibleBody(props: RopTableRowProps) {
    const [open, setOpen] = useState<string[]>(() => {
        const savedConfig = localStorage.getItem("savedCollapsibles");
        return savedConfig ? [...JSON.parse(savedConfig), props.initialSelectedItem] : [];
    });

    useEffect(() => {
        if (props.saveCollapsable) {
            localStorage.setItem("savedCollapsibles", JSON.stringify(open));
        }
    }, [open]);

    return (
        <TableBody>
            {!props.isLoading ? (
                props.collapsibleTable && props.collapsibleTable.length > 0 ? (
                    <>
                        {props.collapsibleTable?.map((row, i) => (
                            <>
                                <TableRow
                                    key={i}
                                    onClick={() => {
                                        props.saveCollapsable ?
                                            setOpen((prev) => {
                                                if (prev.includes(`${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}`)) {
                                                    return prev.filter((item) => item !== `${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}`);
                                                }
                                                return [...prev, `${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}`];
                                            })
                                            :
                                            setOpen((prev) => {
                                                if (prev.includes(`row${i}`)) {
                                                    return prev.filter((item) => item !== `row${i}`);
                                                }
                                                return [...prev, `row${i}`];
                                            });
                                        row.onClick && row.onClick()
                                    }}
                                    hover={props.hover}
                                    sx={{
                                        "&:last-child td, &:last-child th": { border: 0 },
                                        cursor: "pointer",
                                    }}
                                >
                                    <TableCell
                                        sx={{
                                            width: "10%"
                                        }}
                                        align="center"
                                    >
                                        <IconButton
                                            aria-label="expand row"
                                            size="small"
                                            onClick={(e) => props.saveCollapsable ?
                                                setOpen((prev) => {
                                                    e.stopPropagation();
                                                    if (prev.includes(`${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}`)) {
                                                        return prev.filter((item) => item !== `${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}`);
                                                    }
                                                    return [...prev, `${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}`];
                                                })
                                                :
                                                setOpen((prev) => {
                                                    e.stopPropagation();
                                                    if (prev.includes(`row${i}`)) {
                                                        return prev.filter((item) => item !== `row${i}`);
                                                    }
                                                    return [...prev, `row${i}`];
                                                })}
                                        >
                                            {open.includes(props.saveCollapsable ? `${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}` : `row${i}`) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        </IconButton>
                                    </TableCell>
                                    {row.rowItems?.map((e, i) => (
                                        <TableCell
                                            sx={{
                                                display: {
                                                    xs: e.isMobile ? "table-cell" : "none",
                                                    md: "table-cell",
                                                },
                                                width: e.width
                                            }}
                                            key={i}
                                            align={e.align}
                                            component="th"
                                            scope="row"
                                        >
                                            {e.item}
                                        </TableCell>
                                    ))}
                                </TableRow >
                                <RopCollapsibleHistoryTable
                                    open={open}
                                    collapseIndex={i}
                                    collapsibleTableRow={row.historyRows}
                                    collapsibleTableHeader={row.historyHeaders}
                                    title={props.title}
                                    colSpan={props.historyTableColSpan}
                                    historyTableCellSx={props.historyTableCellSx}
                                    hover={props.hover}
                                    saveCollapsable={props.saveCollapsable}
                                    savedKey={`${row.rowItems ? `row${row.rowItems[0].item}` : `row${i}`}`}
                                />
                            </>
                        ))}
                    </>
                ) : (
                    <TableRow>
                        <TableCell
                            sx={{
                                textAlign: "center",
                                borderBottom: "none",
                            }}
                            colSpan={props.itemsHeaders?.length}
                        >
                            <EmptyTable />
                        </TableCell>
                    </TableRow>
                )
            ) : (
                <TableRow>
                    <TableCell
                        sx={{
                            textAlign: "center",
                            borderBottom: "none",
                            height: "100px",
                        }}
                        colSpan={props.itemsHeaders?.length}
                    >
                        <CircularProgress />
                    </TableCell>
                </TableRow>
            )
            }
        </TableBody >
    );
}
